import React from 'react';
import { NavLink } from 'react-router-dom';
import { Users, Building, LayoutDashboard, CreditCard } from 'lucide-react';

const navigation = [
  { name: 'Users', href: '/admin/users', icon: Users },
  { name: 'Organization', href: '/admin/organization', icon: LayoutDashboard },
  { name: 'Domain', href: '/admin/domain', icon: Building },
  { name: 'Billing', href: '/admin/billing', icon: CreditCard },
];

export default function AdminSidebar() {
  // Debug: log the navigation items so you can see Billing is included.
  console.log('AdminSidebar navigation:', navigation);

  return (
    <div className="w-64 bg-white shadow-stickr-sm min-h-screen">
      <div className="p-6 border-b border-light-purple/30">
        <h2 className="text-lg font-semibold text-primary">Admin Portal</h2>
      </div>
      <nav className="p-4">
        <div className="space-y-2">
          {navigation.map((item) => (
            <NavLink
              key={item.name}
              to={item.href}
              className={({ isActive }) =>
                `group flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors ${
                  isActive
                    ? 'bg-light-purple/20 text-primary'
                    : 'text-navy hover:bg-light-purple/10 hover:text-primary'
                }`
              }
            >
              <item.icon className="mr-3 h-5 w-5 flex-shrink-0" />
              {item.name}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
